/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */

import { Component, OnInit, OnDestroy, Inject, ViewChild, ViewChildren, QueryList, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MAT_BOTTOM_SHEET_DATA, MatStepper, MatAutocompleteTrigger } from "@angular/material";
import { FormBuilder, Validators, AbstractControl, FormGroup, FormArray } from "@angular/forms";
import { Observable, Subscription, Subject } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";

import { ApiService, AuthService } from "@app/@core/services";
import { PageService } from "@auth/services";
import { AdminPayrollService } from "@app/@shared/services/admin/payroll";
import { MessageService } from "@app/@shared/components/message/message.service";

@Component({
  selector: "admin-payroll-batch-add-dialog",
  templateUrl: "./payroll-batch-add-dialog.component.html",
  styleUrls: ["./payroll-batch-add-dialog.component.scss"],
})
export class AdminPayrollBatchAddDialogComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private formBuilder: FormBuilder,
    public mbsRef: MatBottomSheetRef,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    public authService: AuthService,
    private pageService: PageService,
    private _notification: MessageService,
    private apiService: ApiService,
    private adminPayrollService: AdminPayrollService
  ) {}

  processing = new Subject<boolean>();
  authForm_default_values = {};
  current_year = new Date().getFullYear();

  months = [
    { value: "01", title: "January" },
    { value: "02", title: "February" },
    { value: "03", title: "March" },
    { value: "04", title: "April" },
    { value: "05", title: "May" },
    { value: "06", title: "June" },
    { value: "07", title: "July" },
    { value: "08", title: "August" },
    { value: "09", title: "September" },
    { value: "10", title: "October" },
    { value: "11", title: "November" },
    { value: "12", title: "December" },
  ];

  public authForm: FormGroup = this.formBuilder.group({
    // Individual Record
    year: [this.current_year, [Validators.min(2016), Validators.max(this.current_year), Validators.required]],
    month: ["", Validators.required],
  });
  get year() {
    return this.authForm.controls.year;
  }
  get month() {
    return this.authForm.controls.month;
  }

  ngOnInit() {}

  ngOnDestroy() {}

  getUpdatedValues() {
    const updatedFormValues = {};
    this.authForm["_forEachChild"]((control, name) => {
      if (control.value != this.authForm_default_values[name]) {
        updatedFormValues[name] = control.value;
      }
    });
    return updatedFormValues;
  }

  submitForm() {
    this.processing.next(true);
    this.apiService.post("admin/payroll", { year: this.year.value, month: this.month.value }).subscribe((res) => {
      if (res.error === false) {
        // Case Created
        this.mbsRef.dismiss(res.data);
        // this.pageService.triggerParentRefresh(true);
        this._notification.create("success", "Success! Payroll Batch added successfully.", { Position: "top", Style: "bar", Duration: 2000 });
      } else if (res.error === true && res.message === "batch_exists") {
        this.month.markAsDirty();
        this.month.setErrors({ exists: true });
      }
      this.processing.next(false);
    });
  }

  resetForm(ref = null, data = null) {
    if (!ref) {
      this.authForm.reset();
    } else {
      const form_field = this.authForm.get(ref);
      if (!form_field.validator) return form_field.reset();
      const validator = form_field.validator({} as AbstractControl);
      if (validator && validator.required) form_field.setValue("");
      else form_field.reset();
    }
  }

  private _filter(value, model): string[] {
    const filterValue = value ? value.toLowerCase() : "";
    return model.filter((option) => option.slug.toLowerCase().includes(filterValue));
  }
}
